
  export default {
    props: {
      header: { type: String, required: false, default: 'Insurance' },
      description: { type: String, required: false, default: 'test description' },
      buttonText: { type: String, required: false, default: 'go now' },
      icon: { type: String, required: false, default: 'generic/globe' },
      link: { type: String, default: null },
      boughtProduct: { type: String, default: '', required: false }
    },
    computed: {
      cheapestBB () {
        return this.$store.getters['utils/getCheapestBroadband'];
      },
      formatCheapBB () {
        return this.$n(this.cheapestBB, 'currency');
      },
      cheapestNRG () {
        return this.$store.getters['utils/getEnergySavings'];
      },
      formatCheapNRG () {
        return this.$n(this.cheapestNRG, 'currencyRound');
      }
    },
    methods: {
      formatPill (header) {
        return header.replace('{bb}', this.formatCheapBB).replace('{nrg}', this.formatCheapNRG);
      }
    }
  };
  